import React from 'react';
import { Field } from 'react-final-form';
import SelectComponent from 'react-select';
import { customStyles } from './external';

export type SelectProps = {
  name: string;
  label: string;
  validate?: any;
  options: any[];
  initialValue?: number | string;
  isSearchable?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  placeholder?: string | React.ReactNode;
};

const classes = {
  label: 'block text-12 mb-10',
  labelOk: 'text-gray-400',
  labelError: 'text-red',
  input:
    'bg-gray-200 w-full h-60 rounded-8 text-black focus:outline-none disabled:bg-gray-100 disabled:text-gray-400',
  inputOk: 'border-gray-300 focus:border-green disabled:border-transparent',
  inputError: 'border-red'
};

const Select: React.FC<SelectProps> = ({
  name,
  label,
  validate,
  options,
  initialValue = '',
  isSearchable,
  isClearable,
  ...props
}) => {
  const inputClasses = (isError: boolean) =>
    classes.input + ' ' + (isError ? classes.inputError : classes.inputOk);

  const selectOptions = options?.map(({ id, name }) => {
    return { value: id, label: name };
  });

  const ReactSelectAdapter = ({ input, meta, ...rest }: any) => {
    const isError = meta.error && (meta.dirty || meta.touched);

    return (
      <SelectComponent
        {...input}
        {...rest}
        isSearchable={isSearchable}
        isClearable={isClearable}
        maxMenuHeight={145}
        className={inputClasses(isError)}
        styles={customStyles}
        classNamePrefix="rootSelector"
      />
    );
  };

  return (
    <Field
      name={name}
      validate={validate}
      initialValue={initialValue}
      component={ReactSelectAdapter}
      options={selectOptions}
      parse={(data) => (data ? data.value : null)}
      format={(value) => (value ? selectOptions?.find((opt) => opt?.value === value) : null)}
      allowNull
      {...props}
    />
  );
};

export default Select;
